export const LicensorRestrictions = (function () {
  let dialog = ({ data = {}, ok = () => {} }) => {
    let template = require(`./tmpl/licensor-restrictions.hbs`);
    bootbox
      .dialog({
        title: data.title,
        message: template(data),
        size: 'xl',
        className: 'modal-scrolled-content modal-licensorRestrictions',
        buttons: {
          Ok: {
            label: `<i class="fal fa-save"></i> ${$lang.btn.save}`,
            className: 'btn btn-primary',
            callback: ok
          },
          Close: {
            label: `<i class="fal fa-times"></i> ${$lang.btn.cancel}`,
            className: 'btn btn-default'
          }
        }
      });
  };

  return {
    dialog
  };
})();
